import React from 'react'
import PropTypes from 'prop-types'

const FooterCopyright = ({year, text}) => {
  return (
    <p>
      &copy;{`${year} ${text}`}
    </p>
  )
}

FooterCopyright.propTypes = {
  year: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
}

export default FooterCopyright



// WEBPACK FOOTER //
// ./src/components/Footer/FooterCopyright.js